import { z } from 'zod';
import { pageOf } from '#src/common/pagination.contract.js';
export const CATALOG_NAME_MAX_LENGTH = 100;
const nameSchema = z.string().trim().min(1).max(CATALOG_NAME_MAX_LENGTH);
/** Categoria dos documentos da caixa (a "Descrição" da planilha). */
export const documentCategorySchema = z.strictObject({
    id: z.uuid(),
    name: z.string(),
    active: z.boolean(),
});
export const documentCategoryPageSchema = pageOf(documentCategorySchema);
export const createDocumentCategoryRequestSchema = z.strictObject({
    name: nameSchema,
});
export const updateDocumentCategoryRequestSchema = z
    .strictObject({
    name: nameSchema.optional(),
    active: z.boolean().optional(),
})
    .refine((body) => Object.keys(body).length > 0, 'Informe ao menos um campo');
//# sourceMappingURL=catalog.contract.js.map